import { omit } from 'lodash';
import { SERVICE_READONLY_FIELDS } from '@onward-delivery/core';

/**
 * Service rows to upsert and service ids to delete when saving the edit modal.
 *
 * @param {Object} args
 * @param {Object[]} [args.pricedServices] Services from the pricing pass; preferred when an array.
 * @param {Object[]} [args.cloneServices] The modal clone's services, the fallback.
 * @param {Object[]} [args.orderServices] The saved order's services, diffed to find removals.
 * @param {string} [args.orderId] Set on every row.
 * @returns {{services: Object[], servicesRemoved: string[]}} Rows without read-only fields, and
 *     ids on the saved order that the edit dropped.
 */
export const buildServicesSavePayload = ({ pricedServices, cloneServices, orderServices, orderId }) => {
    const safeServices = Array.isArray(pricedServices) ? pricedServices : cloneServices || orderServices || [];

    const services = safeServices.map((service) => ({
        ...omit(service, SERVICE_READONLY_FIELDS),
        order_id: orderId,
    }));

    const editedServiceIds = new Set(safeServices.map((service) => service.service_id).filter(Boolean));
    const servicesRemoved = (orderServices || [])
        .filter((service) => service.service_id && !editedServiceIds.has(service.service_id))
        .map((service) => service.service_id);

    return { services, servicesRemoved };
};
